<script>
export default {
  name: "TagDisplay",
  props: {
    // The tag text to display
    tagText: {
      type: String,
      required: false
    },
    clickable: {
      type: Boolean,
      required: false,
      default: false
    },
    color: {
      type: String,
      required: false,
      default: "gray"
    }
  }
};
</script>
<template>
  <div class="tag-display" :class="[color, { clickable }]">
    <span>
      <slot>{{ tagText }}</slot>
    </span>
  </div>
</template>
<style lang="scss" scoped>
.tag-display {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  padding: 10px;
  border: 2px solid;
  span {
    // max-width: fit-content;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    text-align: center;
    line-height: 100% !important;
  }
  &.red {
    color: $main-color;
    border-color: $main-color;
    background-color: rgba($main-color, 0.3);
  }
  &.light-blue {
    color: $light-blue-600;
    border-color: $light-blue-600;
    background-color: rgba($light-blue-600, 0.3);
  }
  &.green {
    color: $correct;
    border-color: $correct;
    background-color: rgba($correct, 0.3);
  }
  &.dark-blue {
    color: $blue-600;
    border-color: $blue-600;
    background-color: rgba($blue-600, 0.3);
  }
  &.gray {
    color: $gray-blue-1300;
    border-color: $gray-blue-1300;
    background-color: rgba($gray-blue-1300, 0.3);
  }
}
</style>
